import React, { useState } from "react";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Box,
  IconButton,
  TableContainer,
  Paper,
} from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";
import { Loading } from "../../sharedComponents/Loading";
import { ModalEditUser } from "./ModalEditUser";
import { ModalDeleteUser } from "./ModalDeleteUser";

export const AdminTable = ({ token, refresh, users, loading }) => {
  const [selectedUser, setSelectedUser] = useState(null);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Paper sx={{ width: "100%", overflow: "hidden" }} elevation={0}>
          <TableContainer
            sx={{ height: "calc(100vh - 300px)", overflowY: "auto" }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  {["Nombre", "Email", "Rol", "Acciones"].map((title) => (
                    <TableCell
                      key={title}
                      style={{
                        fontWeight: "700",
                        backgroundColor: "#f1f1f1",
                        top: 0,
                        zIndex: 1,
                      }}
                    >
                      {title}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {users.map((user, index) => (
                  <TableRow
                    key={user.id}
                    sx={{
                      backgroundColor: index % 2 === 0 ? "white" : "#f5f5f5",
                    }}
                  >
                    <TableCell sx={{ fontSize: "13px" }}>
                      {user.user_name}
                    </TableCell>
                    <TableCell sx={{ fontSize: "13px" }}>
                      {user.email}
                    </TableCell>
                    <TableCell>
                      <span
                        style={{
                          backgroundColor:
                            user.rol === "admin" ? "#fca5a5" : "#7dd3fc",
                          padding: "2px 10px",
                          borderRadius: "12px",
                          textTransform: "capitalize",
                          fontWeight: "600",
                          fontSize: "11px",
                          color: "#000",
                        }}
                      >
                        {user.rol}
                      </span>
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: "flex" }}>
                        <IconButton
                          color="primary"
                          onClick={() => {
                            setSelectedUser(user);
                            setOpenEditModal(true);
                          }}
                        >
                          <Edit />
                        </IconButton>
                        <IconButton
                          sx={{ color: "#ef4444" }}
                          onClick={() => {
                            setSelectedUser(user);
                            setOpenDeleteModal(true);
                          }}
                        >
                          <Delete />
                        </IconButton>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <ModalEditUser
              open={openEditModal}
              onClose={() => setOpenEditModal(false)}
              selectedUser={selectedUser}
              token={token}
              refresh={refresh}
            />
            <ModalDeleteUser
              open={openDeleteModal}
              onClose={() => setOpenDeleteModal(false)}
              selectedUser={selectedUser}
              token={token}
              refresh={refresh}
            />
          </TableContainer>
        </Paper>
      )}
    </>
  );
};
